import * as React from 'react'
import { UITypes } from 'LibNeo'
import { LoaderWrapper, LoaderIcon } from './styled'

interface ComponentProps {
	isVisible: boolean
}

export const LoaderComponent: React.FC<ComponentProps> = ({ isVisible }): JSX.Element => {
	return (
		<LoaderWrapper isVisible={isVisible}>
			<LoaderIcon name="eclipse-loader" type={UITypes.PRIMARY} />
		</LoaderWrapper>
	)
}
